import * as React from 'react';

import styles from './Clients.module.scss';
import Image from '../atoms/Image';

const WantedlyWidget = () => (
  <div className={styles.content}>
    <ul className={styles.clients}>
      <li>
        <Image
          path="Client-Yahoo.png"
          alt="Yahoo! JAPAN"
          className={styles.clients__logo}
        />
      </li>
      <li>
        <Image
          path="Client-Toppan.png"
          alt="凸版印刷株式会社"
          className={styles.clients__logo}
        />
      </li>
      <li>
        <Image
          path="Client-Aiful.png"
          alt="アイフル株式会社"
          className={styles.clients__logo}
        />
      </li>
      <li>
        <Image
          path="Client-CyberAgent.png"
          alt="株式会社サイバーエージェント"
          className={styles.clients__logo}
        />
      </li>
      <li>
        <Image
          path="Client-SophiaUniversity.png"
          alt="上智大学"
          className={styles.clients__logo}
        />
      </li>
      <li>
        <Image
          path="Client-Ringerhut.png"
          alt="株式会社リンガーハット"
          className={styles.clients__logo}
        />
      </li>
      <li>
        <Image
          path="Client-Sembikiya.png"
          alt="千疋屋総本店"
          className={styles.clients__logo}
        />
      </li>
      <li>
        <Image
          path="Client-Toridoll.png"
          alt="TORIDOLL"
          className={styles.clients__logo}
        />
      </li>
      <li>
        <Image
          path="Client-AeonDelightSecurity.png"
          alt="イオンディライトセキュリティ株式会社"
          className={styles.clients__logo}
        />
      </li>
      <li>
        <Image
          path="Client-JaMitsuiLease.png"
          alt="JA三井リース株式会社"
          className={styles.clients__logo}
        />
      </li>
      <li>
        <Image
          path="Client-KobeToyopet.png"
          alt="神戸トヨペット株式会社"
          className={styles.clients__logo}
        />
      </li>
      <li>
        <Image
          path="Client-SamanthaThavasaJapan.png"
          alt="Samantha Thavasa Japan Limited"
          className={styles.clients__logo}
        />
      </li>
    </ul>
  </div>
);

export default WantedlyWidget;
